(function MediaTagPills($, Adzuki)
{
	'use strict';

	/**
	 * How a list view shows a file's tags (MEDIA-327): never more than three pills. Three or
	 * fewer tags show as they are; more show the first two and a "+N more" pill that names the
	 * rest. Display only: search and filters still match every tag.
	 *
	 * In the global bundle so Manage Media and both pickers share the rule.
	 */
	const MAX_PILLS = 3;

	const MediaTagPills = {
		split(tags) {
			const list = Array.isArray(tags) ? tags : [];

			if (list.length <= MAX_PILLS) {
				return {
					shown      : list,
					hidden     : [],
					hiddenNames: '',
				};
			}

			const hidden = list.slice(MAX_PILLS - 1);

			return {
				shown      : list.slice(0, MAX_PILLS - 1),
				hidden     : hidden,
				hiddenNames: hidden.map((tag) => tag.name).join(', '),
			};
		},
		// "+N more" opens the file's details; close its tooltip first, or it stays over the
		// drawer. Tooltips are delegated from <body> (the same hide as toggleLayout), and the
		// button is blurred so focus can't reopen it.
		hideTip(element) {
			if (!element) {
				return;
			}

			$(element).tooltip('hide');
			element.blur();
		},
	};

	Adzuki.MediaTagPills = MediaTagPills;
}(jQuery, window.Adzuki || {}));
